import { render, staticRenderFns } from "./EditarSenha.vue?vue&type=template&id=24b524ea&"
import script from "./EditarSenha.vue?vue&type=script&lang=js&"
export * from "./EditarSenha.vue?vue&type=script&lang=js&"
import style0 from "./EditarSenha.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports